export default __webpack_public_path__ + "static/orangeloop-37-98bf94d69af75d9353d7e9a09d59095e.jpg";